import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { FloatingLabelInputProps } from "@aviary";
import { FloatingLabelInput } from "@aviary";
import { isEmailAtValid, isLengthValid } from "@shared/components/EmailInput";
import { l } from "@unauthenticated/shared/locales/i18n";

interface Props extends Omit<FloatingLabelInputProps, "id" | "label" | "type"> {
  isLoading?: boolean;
  value: string;
  isDirty: boolean;
  isAccountExists: boolean;
}

const SignInEmailInput: FC<Props> = ({ value, isDirty, isAccountExists, isLoading, ...rest }) => {
  const { t } = useTranslation();

  const getErrors = () => {
    if (!isDirty) return null;
    if (!isLengthValid(value)) {
      return t(l.common.EmailRequired);
    }
    if (!isEmailAtValid(value)) {
      return t(l.common.EmailMustHaveAt);
    }
    if (isAccountExists === false && !isLoading) return t(l.signIn.EnterValidEmail);
  };

  return (
    <FloatingLabelInput
      data-e2e="sign-in-email"
      type="email"
      id="email"
      label={t(l.common.Email)}
      errors={[getErrors()]}
      value={value}
      {...rest}
    />
  );
};

export { SignInEmailInput };
